import { capitalize } from 'lodash';

export function sortByFieldName(fieldName) {
  return (a, b) => (a[fieldName] > b[fieldName] ? 1 : -1);
}

export function dateConverter(dateString, format) {
  if (!dateString) return '';
  const date = new Date(dateString);
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  const year = date.getUTCFullYear();
  switch (format) {
    case 'DD/MM/YYYY':
      return `${day}/${month}/${year}`;
    case 'YYYY/MM/DD':
      return `${year}/${month}/${day}`;
    default:
      return `${month}/${day}/${year}`;
  }
}

export function capitalizeFirstLetters(str) {
  return str
    .split(' ')
    .map(word => capitalize(word))
    .join(' ');
}

export function dateConverterForUnits(dateString, format) {
  if (!dateString) return '';

  if (dateString.toString().includes('T')) {
    const date = new Date(dateString);
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    const year = date.getUTCFullYear();
    switch (format) {
      case 'DD/MM/YYYY':
        return `${day}/${month}/${year}`;
      case 'YYYY/MM/DD':
        return `${year}/${month}/${day}`;
      default:
        return `${month}/${day}/${year}`;
    }
  } else if (format === 'YYYY/MM/DD') {
    const cleanValue = dateString.replace(/\D/g, '');

    let formattedValue = '';
    if (cleanValue.length > 0) {
      formattedValue += cleanValue.slice(0, 4);
    }
    if (cleanValue.length > 4) {
      formattedValue += `/${cleanValue.slice(4, 6)}`;
    }
    if (cleanValue.length > 6) {
      formattedValue += `/${cleanValue.slice(6, 8)}`;
    }

    return formattedValue;
  } else {
    const cleanValue = dateString.replace(/\D/g, '');

    let formattedValue = '';
    if (cleanValue.length > 0) {
      formattedValue += cleanValue.slice(0, 2);
    }
    if (cleanValue.length > 2) {
      formattedValue += `/${cleanValue.slice(2, 4)}`;
    }
    if (cleanValue.length > 4) {
      formattedValue += `/${cleanValue.slice(4, 8)}`;
    }

    return formattedValue;
  }
}
